import dayjs, { Dayjs } from "utils/dayjs"

import { Guid, IApiLink, Lmid } from "@/types"

export enum StockTakingSource {
    web = 'web',
    mobile = 'mobile'
}

export interface IGetStocktakingNotScannedAssetDto {
    assetId: Guid
    location: {
        latitude: number
        longitude: number
        isCreatedManually: boolean
        locatingTime: string
        source: StockTakingSource
    }
    connectedAssets: number
}

interface IStocktakingNotScannedAssetAdditionalParams {
    lmid: Lmid
    articleId: Guid
    articleDescription: string
    isLabeled: boolean
    isInCollection: boolean
    linkUpdate?: IApiLink
}

export default class StocktakingNotScannedAsset {
    assetId: Guid
    lastLocationUpdate: Dayjs
    isManualLocation: boolean
    source: StockTakingSource
    connectedAssets: number
    lmid: Lmid
    articleId: Guid
    articleDescription: string
    isLabeled: boolean
    isInCollection: boolean
    linkUpdate?: IApiLink


    constructor(dto: IGetStocktakingNotScannedAssetDto, params: IStocktakingNotScannedAssetAdditionalParams) {
        this.assetId = dto.assetId
        this.lastLocationUpdate = dayjs(dto.location.locatingTime)
        this.isManualLocation = dto.location.isCreatedManually
        this.source = dto.location.source
        this.connectedAssets = dto.connectedAssets
        this.lmid = params.lmid
        this.articleId = params.articleId
        this.articleDescription = params.articleDescription
        this.isLabeled = params.isLabeled
        this.isInCollection = params.isInCollection
        this.linkUpdate = params.linkUpdate
    }

}
